import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchSummaryAnalystForecast } from '@apis/performance';
import type { AnalystForecastApiData } from '@app-types/summaryApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the Analyst Forecast section
 * (GET /api/summary/stocks/analyst-forecast).
 * Reads ticker/mkt from the router location so URL changes refetch.
 */
export const useSummaryAnalystForecast = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<AnalystForecastApiData>({
    queryKey: ['summary', 'analyst-forecast', ticker, mkt],
    queryFn: () => fetchSummaryAnalystForecast({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
